/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { IObservableArray } from "mobx"
import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RoleDtoModel, RoleDtoModelType } from "./RoleDtoModel"
import { RoleDtoModelSelector } from "./RoleDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  roles: IObservableArray<RoleDtoModelType>;
}

/**
 * TeamMemberDtoBase
 * auto generated base class for the model TeamMemberDtoModel.
 */
export const TeamMemberDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('TeamMemberDto')
  .props({
    __typename: types.optional(types.literal("TeamMemberDto"), "TeamMemberDto"),
    id: types.identifier,
    uuid: types.union(types.undefined, types.string),
    email: types.union(types.undefined, types.null, types.string),
    fullname: types.union(types.undefined, types.null, types.string),
    driverProfileInParentOrg: types.union(types.undefined, types.null, types.string),
    roles: types.union(types.undefined, types.array(MSTGQLRef(types.late((): any => RoleDtoModel)))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class TeamMemberDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get uuid() { return this.__attr(`uuid`) }
  get email() { return this.__attr(`email`) }
  get fullname() { return this.__attr(`fullname`) }
  get driverProfileInParentOrg() { return this.__attr(`driverProfileInParentOrg`) }
  roles(builder: string | RoleDtoModelSelector | ((selector: RoleDtoModelSelector) => RoleDtoModelSelector) | undefined) { return this.__child(`roles`, RoleDtoModelSelector, builder) }
}
export function selectFromTeamMemberDto() {
  return new TeamMemberDtoModelSelector()
}

export const teamMemberDtoModelPrimitives = selectFromTeamMemberDto().uuid.email.fullname.driverProfileInParentOrg
